import { FC } from 'react';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import HeadingLevel from 'dibs-controlled-heading/exports/HeadingLevel';
import { FormattedMessage } from 'dibs-react-intl';
import classnames from 'classnames';
import ArticleLink from './ArticleLink';

import { EditorialModuleArticles_articles } from './__generated__/EditorialModuleArticles_articles.graphql';

import styles from './styles/EditorialModuleArticles.scss';

type Props = {
    articles: EditorialModuleArticles_articles;
    useWhiteBg?: boolean;
};

const EditorialModuleArticles: FC<Props> = ({ articles, useWhiteBg }) => {
    return (
        <HeadingLevel>
            {Heading => (
                <div
                    className={classnames(styles.container, { [styles.useWhiteBg]: !!useWhiteBg })}
                >
                    <Heading className={styles.sectionHeader}>
                        <FormattedMessage
                            defaultMessage="Read More"
                            id="dbl.editorialModule.header"
                        />
                    </Heading>
                    <div className={styles.articlesWrapper}>
                        {articles.map((article, index) => (
                            <ArticleLink
                                key={article.publishedDate}
                                article={article}
                                index={index}
                            />
                        ))}
                    </div>
                </div>
            )}
        </HeadingLevel>
    );
};

export default createFragmentContainer(EditorialModuleArticles, {
    articles: graphql`
        fragment EditorialModuleArticles_articles on WordpressArticleType @relay(plural: true) {
            publishedDate
            ...ArticleLink_article
        }
    `,
});
